import styled from "@emotion/styled";

export const LinkStyled = styled.a`
  color: inherit;
`;
